document.addEventListener('DOMContentLoaded', function() {
  const occasionInput = document.getElementById('occasion');
  const signatureInput = document.getElementById('signature');
  const cardMessageInput = document.getElementById('card_message');
  const deliveryInput = document.getElementById('delivery');

  occasionInput.addEventListener('change', function() {
    updateCartAttributes({
      'Occasion Key': occasionInput.value/*,
      'Occasion Title': occasionInput.options[occasionInput.selectedIndex].text*/
    });
  });

  signatureInput.addEventListener('input', function() {
    updateCartAttributes({ 'Signature': signatureInput.value });
  });

  cardMessageInput.addEventListener('input', function() {
    updateCartAttributes({ 'Card Message': cardMessageInput.value });
  });

  deliveryInput.addEventListener('input', function() {
    updateCartAttributes({ 'Instruction': deliveryInput.value });
  });

  function updateCartAttributes(attributes) {
    const formData = new FormData();
    for (const attributeName in attributes) {
      formData.append(`attributes[${attributeName}]`, attributes[attributeName]);
    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    }).then(response => {
      if (response.ok) {
        console.log("Details updated, proceeding to checkout");
        Object.keys(attributes).forEach(attr => {
          console.log(`${attr} details updated: ${attributes[attr]}`);
        });
      } else {
        console.error("Failed to update details");
        response.json().then(data => console.log(data));
      }
    }).catch(error => {
      console.error("Error updating details:", error);
    });
  }
});
